import {EventPresenterProps,} from "@mediaspace/event-platform/event-presenter";
import {StyledPresenterContainer, StyledPresenter} from "./StyledComponents";

export interface PresenterProps extends EventPresenterProps {
    isTranslucent?: boolean;
}

/**
 * single Presenter used in media page
 */
export function Presenter(props: PresenterProps) {

    const {data} = props;

    return (
            <StyledPresenterContainer>
                <a href={data.link}>
                    <StyledPresenter {...props} />
                </a>
            </StyledPresenterContainer>
    );
}

export default Presenter;
